import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-arteh-list-view',
  imports: [],
  templateUrl: './arteh.list-view.html',
  styleUrls: ['./arteh.list-view.css'],
})
export class ArtehListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
